import { ColorTokens, IconSizeTokens, IconTokens, } from '@voltmoney/schema';
export const args = {
    name: 'chat',
};
export const argTypes = {
    name: {
        control: 'select',
        options: [...Object.values(IconTokens)].sort(),
    },
    size: {
        control: 'select',
        options: [...Object.values(IconSizeTokens)],
    },
    color: {
        control: 'select',
        options: [...Object.values(ColorTokens)],
    },
};
